import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store/index.js'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "auth" */ '../views/Auth.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/quotations/:id/edit',
    name: 'EditQuotation',
    component: () => import(/* webpackChunkName: "quotation" */ '../views/Quotation.vue')
  },
  {
    path: '/quotations/new',
    name: 'CreateQuotation',
    component: () => import(/* webpackChunkName: "quotation" */ '../views/Quotation.vue'),
    props: {isCreate: true}
  },
  {
    path: '/quotations',
    name: 'QuotationList',
    component: () => import(/* webpackChunkName: "quotation" */ '../views/QuotationList.vue')
  },
  {
    path: '/subscriptions/:id/edit',
    name: 'EditSubscription',
    component: () => import(/* webpackChunkName: "subscription" */ '../views/Subscription.vue'),
  },
  {
    path: '/subscriptions/new/:quotation_id',
    name: 'CreateSubscriptionFromQuotation',
    component: () => import(/* webpackChunkName: "subscription" */ '../views/Subscription.vue'),
    props: {isCreate: true}
  },
  {
    path: '/subscriptions/new',
    name: 'CreateSubscription',
    component: () => import(/* webpackChunkName: "subscription" */ '../views/Subscription.vue'),
    props: {isCreate: true}
  },
  {
    path: '/subscriptions',
    name: 'SubscriptionList',
    component: () => import(/* webpackChunkName: "subscription" */ '../views/SubscriptionList.vue')
  },
  {
    path: '/invoices',
    name: 'Invoice',
    component: () => import(/* webpackChunkName: "invoice" */ '../views/InvoiceList.vue')
  },
  {
    path: '/invoices/:id/edit',
    name: 'EditInvoice',
    component: () => import(/* webpackChunkName: "invoice" */ '../views/Invoice.vue')
  },
  {
    path: '/createdeliveries',
    name: 'BulkDelivery',
    component: () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryBulk.vue')
  },
  {
    path: '/deliveries',
    name: 'DeliveryList',
    component: () => import(/* webpackChunkName: "delivery" */ '../views/DeliveryList.vue')
  },
  {
    path: '/deliveries/:id/edit',
    name: 'EditDelivery',
    component: () => import(/* webpackChunkName: "delivery" */ '../views/Delivery.vue')
  },
  {
    path: '/accounts',
    name: 'WebAccountList',
    component: () => import(/* webpackChunkName: "webaccounts" */ '../views/WebAccountList.vue')
  },
  {
    path: '/accounts/:id/edit',
    name: 'EditWebAccount',
    component: () => import(/* webpackChunkName: "webaccounts" */ '../views/WebAccount.vue')
  },
  {
    path: '/accounts/new',
    name: 'CreateWebAccount',
    component: () => import(/* webpackChunkName: "webaccounts" */ '../views/WebAccount.vue'),
    props: {isCreate: true}
  },
  {
    path: '/accounts/subscription/:subscription_id',
    name: 'WebAccountListSubscription',
    component: () => import(/* webpackChunkName: "webaccounts" */ '../views/WebAccountList.vue'),
  },
  {
    path: '/accounts/subscription/:subscription_id/new',
    name: 'CreateWebAccountSubscription',
    component: () => import(/* webpackChunkName: "webaccounts" */ '../views/WebAccount.vue'),
    props: {isCreate: true}
  },
  {
    path: '/masters/clients',
    name: 'ClientList',
    component: () => import(/* webpackChunkName: "masters" */ '../views/ClientList.vue')
  },
  {
    path: '/masters/clients/new',
    name: 'CreateClient',
    component: () => import(/* webpackChunkName: "masters" */ '../views/Client.vue'),
    props: {isCreate: true}
  },
  {
    path: '/masters/clients/:id/edit',
    name: 'EditClient',
    component: () => import(/* webpackChunkName: "masters" */ '../views/Client.vue'),
  },
  {
    path: '/masters/addresses',
    name: 'AddressList',
    component: () => import(/* webpackChunkName: "masters" */ '../views/AddressList.vue')
  },
  {
    path: '/masters/addresses/new',
    name: 'CreateAddress',
    component: () => import(/* webpackChunkName: "masters" */ '../views/Address.vue'),
    props: {isCreate: true}
  },
  {
    path: '/masters/addresses/:id/edit',
    name: 'EditAddress',
    component: () => import(/* webpackChunkName: "masters" */ '../views/Address.vue')
  },
  {
    path: '/masters/webmedia',
    name: 'WebMediaList',
    component: () => import(/* webpackChunkName: "masters" */ '../views/WebMediaList.vue')
  },
  {
    path: '/masters/webmedia/new',
    name: 'CreateWebMedia',
    component: () => import(/* webpackChunkName: "masters" */ '../views/WebMedia.vue'),
    props: {isCreate: true}
  },
  {
    path: '/masters/webmedia/:id/edit',
    name: 'EditWebMedia',
    component: () => import(/* webpackChunkName: "masters" */ '../views/WebMedia.vue')
  },
  {
    path: '/masters/deliveryitems',
    name: 'DeliveryItemList',
    component: () => import(/* webpackChunkName: "masters" */ '../views/DeliveryItemList.vue')
  },
  {
    path: '/masters/deliveryitems/new',
    name: 'CreateDeliveryItem',
    component: () => import(/* webpackChunkName: "masters" */ '../views/DeliveryItem.vue'),
    props: {isCreate: true}
  },
  {
    path: '/masters/deliveryitems/:id/edit/',
    name: 'EditDeliveryItem',
    component: () => import(/* webpackChunkName: "masters" */ '../views/DeliveryItem.vue')
  },
  {
    path: '/masters/deliveryitems/:id/detail/',
    name: 'DeliveryItemDetail',
    component: () => import(/* webpackChunkName: "masters" */ '../views/DeliveryItemDetail.vue')
  },
  {
    path: '/masters/products',
    name: 'ProductList',
    component: () => import(/* webpackChunkName: "masters" */ '../views/ProductList.vue')
  },
  {
    path: '/masters/products/new',
    name: 'CreateProduct',
    component: () => import(/* webpackChunkName: "masters" */ '../views/Product.vue'),
    props: {isCreate: true}
  },
  {
    path: '/masters/products/:id/edit/',
    name: 'EditProduct',
    component: () => import(/* webpackChunkName: "masters" */ '../views/Product.vue')
  },
  {
    path: '/masters/products/:id/detail/',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "masters" */ '../views/ProductDetail.vue')
  },
  {
    path: '/ads/quotations',
    name: 'AdsQuotationList',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsQuotationList.vue')
  },
  {
    path: '/ads/quotations/new',
    name: 'CreateAdsQuotation',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsQuotation.vue'),
    props: {isCreate: true}
  },
  {
    path: '/ads/quotations/:id/edit',
    name: 'EditAdsQuotation',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsQuotation.vue'),
  },
  {
    path: '/ads/invoices',
    name: 'AdsInvoiceList',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsInvoiceList.vue')
  },
  {
    path: '/ads/invoices/new',
    name: 'CreateAdsInvoice',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsInvoice.vue'),
    props: {isCreate: true}
  },
  {
    path: '/ads/invoices/new/:quotation_id',
    name: 'CreateAdsInvoiceFromQuotation',
    component: () => import(/* webpackChunkName: "subscription" */ '../views/AdsInvoice.vue'),
    props: {isCreate: true}
  },
  {
    path: '/ads/invoices/:id/edit',
    name: 'EditAdsInvoice',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsInvoice.vue'),
  },
  {
    path: '/ads/deliveries',
    name: 'AdsDeliveryList',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsDeliveryList.vue')
  },
  {
    path: '/ads/deliveries/new',
    name: 'CreateAdsDelivery',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsDelivery.vue'),
    props: {isCreate: true}
  },
  {
    path: '/ads/deliveries/new/:invoice_id',
    name: 'CreateAdsDeliveryFromInvoice',
    component: () => import(/* webpackChunkName: "subscription" */ '../views/AdsDelivery.vue'),
    props: {isCreate: true}
  },
  {
    path: '/ads/deliveries/:id/edit',
    name: 'EditAdsDelivery',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsDelivery.vue'),
  },
  {
    path: '/ads/payments',
    name: 'AdPayment',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdPayment.vue')
  },
  {
    path: '/ads/product',
    name: 'AdsProductList',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsProductList.vue')
  },
  {
    path: '/ads/product/new',
    name: 'CreateAdsProduct',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsProduct.vue'),
    props: {isCreate: true}
  },
  {
    path: '/ads/adsproduct/:id/edit/',
    name: 'EditAdsProduct',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsProduct.vue')
  },
  {
    path: '/ads/adsproduct/:id/detail/',
    name: 'AdsProductDetail',
    component: () => import(/* webpackChunkName: "billing" */ '../views/AdsProductDetail.vue')
  },
  {
    path: '/ads/sales',
    name: 'AdSales',
    component: () => import(/* webpackChunkName: "billing" */ '../views/Sales.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(page => page.meta.isPublic) || Store.getters.token) {
    next()
  } else {
    next({'name': 'Auth'})
  }
})


export default router
